import { __assign } from "tslib";
import React from 'react';
import { StyleSheet, View, TextInput } from 'react-native';
import moment from 'moment';
// Custom
import c from '../styles/_colors.js';
import PnmacTextMobile from '../Typography/PnmacTextMobile';
import DollarInput from '../DollarInput';
import { formatDollar } from '../utils.js';
var inputProps = function (props) {
  return {
    onChangeText: props.onChangeText,
    value: props.value,
    style: s.input(props),
    keyboardType: props.keyboardType || 'default'
  };
};
var DisplayType = function (props) {
  if (props.value === null || props.value === "") {
    return "N/A";
  } else if (props.dollar) {
    return formatDollar(props.value);
  } else if (props.date) {
    if (props.monthOnly) {
      return moment(props.value).format('MMM YYYY');
    } else {
      return moment(props.value).format('MMM D, YYYY');
    }
  } else if (props.percent) {
    return "".concat(props.value, "%");
  } else {
    return props.value;
  }
};
var InputRow = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s.container
  }, /*#__PURE__*/React.createElement(View, {
    style: s.innerContainer
  }, /*#__PURE__*/React.createElement(View, {
    style: s.leftInput
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: s.text(props)
  }, props.label)), props.onChangeText ? props.dollar ? /*#__PURE__*/React.createElement(View, {
    style: s.rightInput
  }, /*#__PURE__*/React.createElement(DollarInput, __assign({}, inputProps(props)))) : /*#__PURE__*/React.createElement(View, {
    style: s.rightInput
  }, /*#__PURE__*/React.createElement(TextInput, __assign({}, inputProps(props)))) : /*#__PURE__*/React.createElement(View, {
    style: s.rightInput
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: s.input(props)
  }, props.value))), !props.last && /*#__PURE__*/React.createElement(View, {
    style: s.line
  }));
};
export default InputRow;
var s = {
  container: {},
  innerContainer: {
    width: "100%",
    flex: 1,
    flexDirection: 'row',
    paddingVertical: 10,
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  leftInput: {
    flex: 5
  },
  rightInput: {
    flex: 2,
    paddingRight: 20
  },
  line: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: c.lighterGray
  },
  text: function (props) {
    return __assign(__assign(__assign({
      paddingVertical: 2,
      paddingRight: 10,
      paddingLeft: 20
    }, props.darkLabel ? {
      color: c.black
    } : {}), props.boldLabel ? {
      fontWeight: '700'
    } : {}), props.boldLabel ? {
      color: c.black
    } : {});
  },
  input: function (props) {
    return __assign({
      flexGrow: 1,
      alignSelf: 'flex-end',
      textAlign: 'right',
      paddingVertical: 2,
      fontSize: 14,
      color: props.cyanValue ? c.darkCyan : c.black
    }, props.bold ? {
      fontWeight: '700'
    } : {});
  }
};